module.exports = __webpack_public_path__ + "assets/e4961a49ccbd845217d3e25abbacf23b.svg";